module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/command-center-maxlvl-50.3fd4271d.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/command-center-maxlvl-50.png
// module id = 3524
// module chunks = 11